import { put, takeEvery } from "redux-saga/effects";

import { ApiGatewayApi } from "api";
import { addNotification, loading } from "layouts/AppLayout/modules";
import * as Actions from "../actions/UpdateOrganization";

export function* updateOrganization(action: Actions.UpdateOrganizationAction) {
    const { payload } = action;
    const { credentials, organization } = payload;
    const { organizationId, ...updateOrg } = organization;

    delete (updateOrg as any)["creationDate"];

    try {
        const api = new ApiGatewayApi({
            xappUserToken: credentials.accessToken
        });
        yield put(loading(true, action));
        // @ts-ignore yields generate implicit anys as of TS 4.2
        const org = yield api.updateOrg(organizationId, { set: updateOrg });
        yield put(addNotification(`${org.name} successfully updated`));
        yield put(Actions.updateOrganizationEnd(undefined, org));
    } catch (e) {
        yield put(addNotification(e.message, true));
        yield put(Actions.updateOrganizationEnd(e));
    } finally {
        yield put(loading(false, action));
    }
}

export function* watchUpdateOrganization() {
    yield takeEvery(Actions.UPDATE_ORGANIZATION, updateOrganization);
}
